import {create} from 'zustand';

type CartStore = {
  isOpen: boolean;
  toggleOpen: () => void;
  handleClose: () => void;
};

export const useCartStore = create<CartStore>((set) => ({
  isOpen: false,
  toggleOpen: () => set((state) => ({isOpen: !state.isOpen})),
  handleClose: () => set(() => ({isOpen: false})),
}));
